module.exports = __webpack_public_path__ + "static/media/check-circle.2b692e54.svg";